// Free-tier usage caps. Walter 2026-05-31 (abuse/cost ceiling).
//
// These are SOFT, client-enforced caps — a usage nudge toward the
// eventual Pro tier + a cost backstop, NOT a security boundary. Hard
// server-side enforcement would mean routing all board/list creation
// through Cloud Functions (a big rebuild); the kill-switch + cron
// health monitoring cover true abuse. When Pro ships, gate these on
// the user's tier instead of hardcoding.
//
// "lists total including archived" is satisfied naturally by counting
// the lists subcollection — archive is a `state` flag on the doc, not
// a move, so archived lists still count.
export const FREE_TIER = {
  maxBoards: 10,
  maxListsTotal: 500,
};

// Copy shown when a free-tier cap is hit. Kept here so the wording is
// consistent across the board + list entry points and easy to tweak.
export const LIMIT_COPY = {
  boards: `You've reached the free limit of ${FREE_TIER.maxBoards} boards. We're building a Pro tier with much more room — for now, delete a board you don't need to make space.`,
  lists: `You've reached the free limit of ${FREE_TIER.maxListsTotal} lists. We're building a Pro tier with much more room — for now, delete or clear some lists to make space.`,
};
